import type { VNode } from 'preact';

import { toggleCompared } from 'Core/actions/localStorage';
import { useDispatch, useSelector } from 'Core/store';
import type SearchItemData from 'Models/searchItemData';

interface Props {
  item: SearchItemData;
}

export default function ComparerCheckBox({ item }: Props): VNode<object> {
  const checked = useSelector((state) => state.localStorage.compared.some(({ key }) => key === item.key));

  const dispatch = useDispatch();
  const onChange = () => dispatch(toggleCompared(item));

  const props = {
    checked,
    className: 'cm_comparer-checkbox',
    title: checked ? 'Remove from compared' : 'Select products to compare',
    type: 'checkbox',
    onChange,
  };
  return <input {...props} />;
}
